import { Component, inject, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MakeAppointmentService } from '../service/make-appointment.service';
import { PatientDataForAppoinment } from '../service/make-appoinment.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { SharedService } from 'src/app/services/shared.service';
import { ToastService } from 'src/app/services/toast.service';
import { ToastType } from 'src/app/enums/enums';

@Component({
  selector: 'app-mds-appointment',
  templateUrl: './mds-appointment.component.html',
  styleUrls: ['./mds-appointment.component.scss']
})
export class MDsAppointmentComponent {
  MDAppoinmentForm: FormGroup;
  @Input() patientData: PatientDataForAppoinment = {
    id: 0,
    name: '',
    caseName: '',
    da: '',
    de: '',
    clinicId: 0,
    isDischarged: false
  };
  isData = false;
  activeModal = inject(NgbActiveModal);
  currentDate = new Date();
  minCurrDate = new Date().toISOString().split('T')[0];

  constructor(private makeAppointmentService: MakeAppointmentService, private sharedService: SharedService, private toast: ToastService) {
    this.MDAppoinmentForm = new FormGroup({
      nextMDAppt: new FormControl(null),
      mdprn: new FormControl(false),
      internist: new FormControl(null),
      internistFU1: new FormControl(null),
      internistFU2: new FormControl(null),
      internistFU3: new FormControl(null),
      internistFU4: new FormControl(null),
      internistFU5: new FormControl(null),
      internistFU6: new FormControl(null),
      internistFU7: new FormControl(null),
      internistFU8: new FormControl(null),
      internistFU9: new FormControl(null),
      internistFU10: new FormControl(null),
      internistFU11: new FormControl(null),
      internistFU12: new FormControl(null),
      internistFU13: new FormControl(null),
      internistFU14: new FormControl(null),
      internistFU15: new FormControl(null),
      nextROMAppt: new FormControl(null),
      noROM: new FormControl(false),
      rom: new FormControl(null),
      roM2: new FormControl(null),
      roM3: new FormControl(null),
      roM4: new FormControl(null),
      roM5: new FormControl(null)
    });
    this.currentDate.setHours(0, 0, 0, 0);
  }

  ngOnInit() {
    this.MDAppoinmentForm.get('nextMDAppt')?.valueChanges.subscribe(() => {
      this.checkDate('nextMdDiv', 'mdprn', 'nextMDAppt');
    });
    this.MDAppoinmentForm.get('mdprn')?.valueChanges.subscribe(() => {
      this.checkDate('nextMdDiv', 'mdprn', 'nextMDAppt');
    });
    this.MDAppoinmentForm.get('nextROMAppt')?.valueChanges.subscribe(() => {
      this.checkDate('nextRomDiv', 'noROM', 'nextROMAppt');
    });
    this.MDAppoinmentForm.get('noROM')?.valueChanges.subscribe(() => {
      this.checkDate('nextRomDiv', 'noROM', 'nextROMAppt');
    });
    this.getMDAppoinment(this.patientData.id);
  }

  getMDAppoinment(id: number) {
    this.makeAppointmentService.getMDAppoinment(id).subscribe({
      next: (res) => {
        this.isData = true;
        const data = this.sharedService.changeDateToString(res.result);
        const { id, patientId, clinicId, ...rest } = data;
        this.MDAppoinmentForm.setValue(rest);
      },
      error: (error) => {
        console.error(error, 'error');
      },
      complete: () => {}
    });
  }

  makeMDAppoinment() {
    let data = this.MDAppoinmentForm.value;
    data.patientId = this.patientData.id;
    data.clinicId = this.patientData.clinicId;
    this.makeAppointmentService.makeMDAppoinment(data).subscribe({
      next: (result) => {
        this.toast.showToast({
          message: 'MD Appointment created successfully !',
          type: ToastType.Info
        });
      },
      error: (error) => {
        this.toast.showToast({
          message: error.message,
          type: ToastType.Error
        });
      },
      complete: () => {
        this.activeModal.dismiss();
      }
    });
  }

  updateMDAppointment() {
    let data = this.MDAppoinmentForm.value;
    data.patientId = this.patientData.id;
    data.clinicId = this.patientData.clinicId;

    const dateFields = [
      'nextMDAppt',
      'internist',
      'internistFU1',
      'internistFU2',
      'internistFU3',
      'internistFU4',
      'internistFU5',
      'internistFU6',
      'internistFU7',
      'internistFU8',
      'internistFU9',
      'internistFU10',
      'internistFU11',
      'internistFU12',
      'internistFU13',
      'internistFU14',
      'internistFU15',
      'nextROMAppt',
      'rom',
      'roM2',
      'roM3',
      'roM4',
      'roM5'
    ];
    dateFields.forEach((field) => {
      if (data[field] === '') {
        data[field] = null;
      }
    });

    data = this.sharedService.changeStringToDate(data);
    this.makeAppointmentService.updateMDAppoinment(data).subscribe({
      next: (result) => {
        this.toast.showToast({
          message: 'MD Appointment updated successfully !',
          type: ToastType.Info
        });
      },
      error: (error) => {
        this.toast.showToast({
          message: error.message,
          type: ToastType.Error
        });
      },
      complete: () => {
        this.activeModal.dismiss();
      }
    });
  }

  checkDate(div: string, checkbox: string, mainField: string) {
    const myDiv = document.getElementById(div);
    const checkboxValue = this.MDAppoinmentForm.get(checkbox)?.value;
    const mainFieldValue = this.MDAppoinmentForm.get(mainField)?.value;
    if (!checkboxValue && this.isData && mainFieldValue) {
      const date2 = new Date(mainFieldValue);
      if (this.currentDate > date2) {
        myDiv?.classList.add('highlight-red');
      } else {
        myDiv?.classList.remove('highlight-red');
      }
    } else {
      myDiv?.classList.remove('highlight-red');
    }
  }
}
